// extracted by mini-css-extract-plugin
export default {"flow":"styles_flow__agF+s"};